export const ru = {
    add: 'Добавить',
    execution_date: 'Дата оформления',
    registry_date: 'Дата в реестре',
    collate_registry: 'Сверка реестра',
};
